import {CircularProgress, Grid} from '@mui/material';
import ErrorMsg from '../../../shared/components/finmobile-error-msg';
import {
  ApplicationStatusState,
  emptyApplicationStatus,
} from '../../../security/model/application-status';
import {Snackbar} from '@finpay-development/shared-components';
import React from 'react';

interface Props {
  isPageLoading: boolean;
  isAuthDocAlreadyApproved: boolean;
  areRecordsReady: boolean;
  approvalView: React.ReactElement;
  errorMsg: string;
  msgState: [
    ApplicationStatusState,
    React.Dispatch<React.SetStateAction<ApplicationStatusState>>,
  ];
  alreadyApprovedText: string;
}

export const NoSigAuthDocApprovalPage = ({
                                           isPageLoading,
                                           isAuthDocAlreadyApproved,
                                           areRecordsReady,
                                           approvalView,
                                           errorMsg,
                                           msgState,
                                           alreadyApprovedText,
                                         }: Props) => {

  const [msg, setMsg] = msgState;

  return (
      <Grid
          container
          justifyContent="center"
          sx={{width: '100vw'}}
      >
        <>
          {(() => {

            switch (true) {

              case isPageLoading:
                return (
                    <Grid
                        item
                        container
                        justifyContent="center"
                    >
                      <Grid item sx={{marginTop: '3rem'}}>
                        <CircularProgress/>
                      </Grid>
                    </Grid>
                );

              case isAuthDocAlreadyApproved:
                return (
                    <Grid>
                      <ErrorMsg
                          errorStatus={true}
                          errorMessageHeader={''}
                          errorMessageContent={(
                              <>
                                {alreadyApprovedText}
                                <br/>
                                For further support, please contact FinPay at
                                support@finpay.com.
                              </>
                          )}
                      />
                    </Grid>
                );

              case areRecordsReady:
                return approvalView;

              default:
                return (
                    <Grid>
                      <ErrorMsg
                          errorStatus={true}
                          errorMessageHeader={''}
                          errorMessageContent={(
                              <>{errorMsg}</>
                          )}
                      />
                    </Grid>
                );
            }
          })()}

          <Snackbar
              open={!!msg?.showMessage}
              message={msg.message}
              type={msg?.messageType}
              onClose={() => {
                setMsg(emptyApplicationStatus);
              }}
          />
        </>
      </Grid>
  );

};